import { render, staticRenderFns } from "./cart.vue?vue&type=template&id=1b2a07c6&scoped=true&"
import script from "./cart.vue?vue&type=script&lang=js&"
export * from "./cart.vue?vue&type=script&lang=js&"
import style0 from "./cart.vue?vue&type=style&index=0&id=1b2a07c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2a07c6",
  null
  
)

export default component.exports